<template>
    <div class="router-view-content">
        <h1>Kody promocyjne</h1>
        <h2>Edytuj webinar z listy lub dodaj nowy</h2>
        <div
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0;
            "
        >
            <!-- <input placeholder="Szukaj" @input="searchPromos" type="search" /> -->
            <!-- TODO: ADD PRODUCT QUERY -->
            <ActionButton
                label="Dodaj kod"
                color="apple"
                @click="openCreator"
            />
        </div>
        <RegularList
            @action="actionEmitted"
            @itemSelected="editCode"
            :loading="initLoading"
            :header="listHeader"
            :items="listItems"
        />
        <transition name="fade">
            <PromoCreator
                :selectedPromo="selectedPromo"
                @close="closeCreator"
                @update="promoUpdated"
                v-if="creatorVisible"
            />
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        PromoCreator: () => import('./PromoCreator')
    },
    data() {
        return {
            listHeader: [
                {
                    display: 'Kod',
                    size: 2
                },
                {
                    display: 'Zniżka',
                    size: 2
                },
                {
                    display: 'Produkt',
                    size: 2
                },
                {
                    display: 'Aktywny?',
                    size: 2
                }
            ],
            promos: [],
            creatorVisible: false,
            selectedPromo: {},
            initLoading: true,
            loading: false
        }
    },
    computed: {
        listItems() {
            return this.promos.map(promo => {
                return {
                    key: promo.token,
                    payload: promo,
                    more: this.getMenuOptions(promo),
                    cells: [
                        {
                            type: 'text',
                            display: promo.token,
                            size: 2
                        },
                        {
                            type: 'text',
                            display: `${promo.discount}%`,
                            size: 2
                        },
                        {
                            type: 'text',
                            display: this.getProduct(promo.products[0]),
                            size: 2
                        },
                        {
                            type: 'text',
                            display: promo.is_active ? 'Tak' : 'Nie',
                            size: 2
                        }
                    ]
                }
            })
        }
    },
    methods: {
        searchPromos(input) {
            const search = `"*${input.target.value}*"`
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                const query = `?query=((uuid=i=${search}) OR (title=i=${search}))`
                this.getPromos(query)
            }, 1000)
        },
        actionEmitted(action) {
            switch (action.name) {
                case 'copy':
                    this.$copyText(action.payload).then(() => {
                        this.$Notif.success('LABEL_COPIED')
                    })
                    break
                case 'delete':
                    this.deletePromo(action.payload)
                    break
            }
        },
        deletePromo(promo) {
            if (this.loading) {
                return
            }
            this.loading = true
            this.$api
                .remove(`v1/vod/codes/${promo}`)
                .then(() => {
                    this.getPromos()
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.loading = false
                })
        },
        getMenuOptions(promo) {
            return [
                {
                    event: {
                        name: 'copy',
                        payload: promo.token
                    },
                    materialIcon: 'content_copy',
                    display: 'Kopiuj kod'
                },
                {
                    event: {
                        name: 'delete',
                        payload: promo.id
                    },
                    materialIcon: 'delete',
                    display: 'Usuń kod'
                }
            ]
        },
        getProduct(product) {
            const webinar = this.$store.getters['content/productByUUID'](
                product
            )
            return webinar ? webinar.title : product
        },
        promoUpdated() {
            this.getPromos()
            this.closeCreator()
        },
        closeCreator() {
            this.creatorVisible = false
            this.selectedPromo = {}
        },
        openCreator() {
            this.creatorVisible = true
        },
        editCode(promo) {
            this.selectedPromo = promo
            this.openCreator()
        },
        getPromos(q = '') {
            this.$api
                .get(`v1/vod/codes?${q}&sort=created&reverse=true`)
                .then(({ data }) => {
                    this.promos = data
                })
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        }
    },
    mounted() {
        this.getPromos()
    }
}
</script>
